import { useEffect, useState } from 'react';

/** Default max-width (px) for “narrow” layout; keep in sync with CSS `--edit-layout-breakpoint-px` in main.css. */
export const NARROW_VIEWPORT_BREAKPOINT_PX = 768;

function getMatchesNarrow(mql: MediaQueryList): boolean {
  return mql.matches;
}

export function useIsNarrowViewport(
  breakpointPx: number = NARROW_VIEWPORT_BREAKPOINT_PX,
): boolean {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === 'undefined') return false;
    return getMatchesNarrow(
      window.matchMedia(`(max-width: ${breakpointPx}px)`),
    );
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia(`(max-width: ${breakpointPx}px)`);
    const onChange = () => {
      setIsNarrow(getMatchesNarrow(mql));
    };

    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpointPx]);

  return isNarrow;
}

/**
 * Narrow viewport for **edit mode** chrome and layout (SkillPanel, ControlBar, TreeEdit; compact
 * header, dev panel column, title bar visibility). Uses the default breakpoint; distinct from any
 * future view-mode-only heuristics that might use a different threshold or signals.
 */
export function useIsEditLayoutNarrowViewport(): boolean {
  return useIsNarrowViewport();
}
